import { Navigate, useLocation } from "react-router-dom"
import { useAuth0 } from "@auth0/auth0-react"
import { env } from "@/lib/env"

interface AuthGateProps {
  children: React.ReactNode
}

export function AuthGate({ children }: AuthGateProps) {
  const { isAuthenticated, isLoading } = useAuth0()
  const location = useLocation()

  // In "public" mode, skip auth checks and always render children
  if (env.VITE_UI_SHELL_MODE === "public") {
    return <>{children}</>
  }

  // Show loading state while Auth0 is initializing
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent mx-auto" />
          <p className="mt-4 text-sm text-muted-foreground">Signing in...</p>
        </div>
      </div>
    )
  }

  // If not authenticated, redirect to sign-in page
  // Preserve the current path so we can redirect back after login
  if (!isAuthenticated) {
    return (
      <Navigate
        to="/sign-in"
        state={{ from: location.pathname }}
        replace
      />
    )
  }

  // User is authenticated, render the protected content
  return <>{children}</>
}
